import { default as ApiConstants } from 'shared/constants/ApiConstants.json';
import ApiUtils from 'shared/modules/ApiUtils';

const getOrderAPI = () => ApiUtils.getRequest(ApiConstants.ORDER_ENDPOINT);
const creatOrderAPI = (payload: Record<string, unknown> | null | undefined) =>
    // console.log('payloadsssss',payload);
    ApiUtils.postRequest(ApiConstants.ORDERS_ENDPOINT, payload);

export {getOrderAPI, creatOrderAPI };
